<template>
    <sub-page
        class="m-addTopicByBatch"
        :class="{'from-paper': fromPaper}"
        :fullPage="true"
    >
        <div class="batch-wrapper">
            <div class="batch-box batch-box-input">
                <div class="box-header">
                    <h3 class="title">输入区</h3>
                    <div class="toolbar">
                        <el-button @click="showExample(1)" type="text">
                            输入范例 <i class="nucfont inuc-arrow-right" :class="{'active': example===1}"></i>
                        </el-button>
                        <el-button @click="showExample(2)" type="text">
                            格式要求 <i class="nucfont inuc-arrow-right" :class="{'active': example===2}"></i>
                        </el-button>
                    </div>
                </div>

                <div class="box-body">
                    <div class="box-example" id="example1">
                        <p class="type-tag type-single"></p>
                        1、安检人员的基本职责和行为准则是( )。
                        <br/>(A)严守秘密，保证安全
                        <br/>(B)严格检查，文明服务
                        <br/>(C)保证安全，文明服务
                        <br/>(D)严格检查，确保安全
                        <br/>正确答案:C
                        <br/>解析：
                        <br/><br/>

                        <p class="type-tag type-multi"></p>
                        1、职业道德是正确处理职业内部、职业之间、职业与社会之间、人与人之间关系时应当遵循的（ ）的规范。
                        <br/>（A）职业环境
                        <br/>（B）职业风俗
                        <br/>（C）职业习惯
                        <br/>（D）职业实践
                        <br/>正确答案：CD
                        <br/>解析:
                        <br/><br/>

                        <p class="type-tag type-judge"></p>
                        1、 要文明执勤，树立为旅客服务的思想是安全技术检查部门的服务职能。
                        <br/>正确答案:对
                        <br/>解析:
                    </div>
                    <div class="box-example" id="example2">
                        <p class="tag">格式要求</p>
                        1、所有题型标号支持 <b>1.</b> 或 <b>1、</b> 格式。
                        <br/>2、所有题型必须含有 <b>"正确答案："</b> 字段，且不能为空。
                        <br/>3、所有题型 <b>"解析："</b> 字段非必需，没有可不填。
                        <br/>4、选择题 A-G 这些选项号要用括号包起来：<b>(A)</b>。
                        <br/>5、选择题最少支持2个选项 <b>A,B</b>，最多支持7个选项 <b>A,B,C,D,E,F,G</b> 且按照顺序使用。
                        <br/>6、选择题答案中请勿加分隔符或者空格。
                        <br/>7、判断题答案必须为 <b>“对”</b> 和 <b>“错”</b>。
                    </div>

                    <quill-editor
                        class="batch-editor"
                        v-model="contentRT"
                        ref="contentRT">
                    </quill-editor>
                </div>
            </div>

            <div class="batch-box batch-box-result">
                <div class="box-header">
                    <h3 class="title">检查区</h3>
                    <div class="count">
                        <p class="total">题数：<b>{{ topics.length }}</b></p>
                        <p class="wrong" v-show="errorNum">错误：<b>{{errorNum}}</b></p>
                    </div>
                </div>

                <div class="box-body">
                    <div class="batch-preview">
                        <ul class="paper-list">
                            <li v-for="(item, index) in topics"
                                :class="{'is-error': item.isError}"
                                :key="index">
                                <div class="detail">
                                    <div class="topic-title">
                                        <p class="type-tag" :class="['type-single', 'type-multi', 'type-judge'][item.type - 1]"></p>
<!--                                        <p class="titleRT" v-if="!item.error.title">{{ item.title }}</p>-->
                                        <p class="titleRT" v-if="!item.error.title" v-html="item.titleRT"></p>
                                        <p class="titleRT error" v-else>{{ item.error.title }}</p>
                                    </div>

                                    <div class="topic-choice-error error" v-if="item.error.option">
                                        {{ item.error.option }}
                                    </div>

                                    <!-- 选项 -->
                                    <ul>
                                        <li v-for="(v, i) in item.options" class="topic-choice"
                                            :class="{'rightAnswer': v.isRight}"
                                            :key="i">
                                            <el-radio v-if="item.type === 1" :value="true" :label="v.isRight">
                                                <em>{{ v.tag }}.</em>
<!--                                                <div class="options">{{ v.title }}</div>-->
                                                <div class="options" v-html="v.titleRT"></div>
                                            </el-radio>
                                            <el-checkbox v-if="item.type === 2" :value="v.isRight">
                                                <em>{{ v.tag }}.</em>
<!--                                                <div class="options">{{ v.title }}</div>-->
                                                <div class="options" v-html="v.titleRT"></div>
                                            </el-checkbox>
                                            <el-radio v-if="item.type === 3" :value="true" :label="v.isRight">
                                                <em>{{ v.tagName }}</em>
                                            </el-radio>
                                        </li>
                                    </ul>
                                </div>

                                <div class="others">
                                    <p class="answer" v-if="!item.error.answer">
                                        <span class="tag">{{ $t('paper.answer') }}：</span>{{ item.keyName }}
                                    </p>
                                    <p class="answer error" v-else>{{ item.error.answer }}</p>
                                    <p class="analysis">
                                        <span class=tag>{{ $t('paper.analysis') }}：</span>
<!--                                        <span>{{ item.analysis || $t('c.none') }}</span>-->
                                        <span v-html="item.analysisRT || $t('c.none')"></span>
                                    </p>
                                </div>
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>

        <div class="batch-form" v-if="!fromPaper">
            <el-form
                :model="topicForm"
                :rules="topicRules"
                class="topic-form"
                ref="topicForm"
                size="small"
                label-position="left">

                <div class="select-group">
                    <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                        <el-select v-model="topicForm.forLevel" :placeholder="$t('tip.operatorLevel')" style="width:210px;">
                            <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('c.difficulty')" prop="difficulty">
                        <el-select v-model="topicForm.difficulty" :placeholder="$t('tip.difficulty')" style="width:210px;">
                            <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                                       :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item :label="$t('c.knowledgePoint')" prop="knowledge">
                        <el-cascader
                            v-model="topicForm.knowledge"
                            :options="knowledgeMenu['Theory']"
                            :props="cascadeProp"
                            :show-all-levels="false"
                            style="width:210px;"
                        ></el-cascader>
                    </el-form-item>
                </div>
            </el-form>

            <el-button @click="saveTopic" class="btn-save" type="primary" size="medium" :loading="topicLoading">提交</el-button>

        </div>
    </sub-page>
</template>

<script>
/**
 * todo:
 *  、暂存功能
 */
import QuillEditor from "@/components/QuillEditor"
import {mapGetters} from "vuex";

const nameReg = /^\s*\n*\d+[,.．、，。]/
const questionReg = /^\s*\n*[(|（][A-G][)|）]/i
const questionInlineReg = /[(|（][A-G][)|）]/gi
const answerReg = /^\n*\s*(正确)?答案[:：]\s*/g
const analysisReg = /^\n*\s*(解析[:：])\s*/g

export default {
    components: {
        QuillEditor
    },

    props: {
        fromPaper: {
            type:  Boolean,
            default: false
        }
    },

    data() {
        return {
            content: '',
            contentRT: '',
            topicLength: 0,
            topics: [],
            toolbar: '',
            example: 0,

            topicForm: {
                difficulty: '',
                forLevel: '',
                knowledge: [],
            },
            topicRules: {
                forLevel: [
                    {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                ],
                difficulty: [
                    {required: true, message: this.$t('tip.difficulty'), trigger: 'change'}
                ],
                knowledge: [
                    {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                ],
            },
            difficultyDict: [],
            cascadeProp: {
                value: 'id',
                label: 'value',
                children: 'children'
            },
            topicLoading: false
        }
    },

    computed: {
        errorNum() {
            if (this.topics.length) {
                let len = this.topics.filter(item => item.isError).length
                return len
            }

            return 0
        },
        ...mapGetters([
            'forLevelMenu',
            'knowledgeMenu'
        ]),
    },

    watch: {
        topics(v) {
            console.log(v)
        },
        contentRT(v) {
            let newArr = []
            let indexArr = []
            let questionArr = []
            let contentText = v.replace(/<p>/g, "\n").replace(/<\/p>/g, "\n").replace(/<br>/g, "\n").split('\n')

            // 去除空格，提取文本
            contentText.forEach(function (value) {
                if (value) {

                    value = value.replace(/&nbsp;/g, ' ');

                     // const htmlReg = /(?<=>)[^<>]+(?=<)/g
                     // 如果这行字中有各种html标签，则去掉
                     //if (value.match(htmlReg)) {
                        //value = value.match(htmlReg).join('')

                        // 将 <***> 及 </***> 替换成""
                        let reg = /<[^<>]+>|<\/[a-zA-Z]+>/g
                        value = value.replace(reg, '')
                     //}

                    /**
                     * 处理将几个选项写在了一行的情况
                     * optionsMatch = ["(A)", "(B)", "(C)", "(D)"] // 全写在一行
                     * optionsMatch = ["(A)"] // 选项正常换行
                     */
                    let optionsMatch = value.match(questionInlineReg)

                    if (optionsMatch && optionsMatch.length > 1) {
                        // 分别找到ABCD在字符串中的位置，放进数组
                        let optionPositionArr = []
                        optionsMatch.forEach(v => {
                            let idx = value.indexOf(v)
                            optionPositionArr.push(idx)
                        })

                        // 根据ABCD的位置，对应地截取字符串
                        optionPositionArr.forEach((v, i) => {
                            newArr.push(value.substring(v, optionPositionArr[i + 1]))
                        })
                        return
                    }

                    newArr.push(value)
                }
            });

            //console.log(newArr)

            // 寻找相应的下标
            newArr.forEach(function (value, index) {
                if (value.match(nameReg)) {
                    indexArr.push(index)
                }
            });

            // 截取完整小题
            indexArr.forEach(function (value, index) {
                questionArr.push(newArr.slice(indexArr[index], indexArr[index + 1]))
            });

            this.topicLength = questionArr.length

            this.makeTopic(questionArr)
        }
    },

    mounted() {
        this.$store.dispatch('getForLevelMenu');

        this.$store.dispatch('getKnowledgeMenu', {
            type: 'Theory'
        })

        this.$api.getDifficulty().then(res => {
            this.difficultyDict = res.package;
        });

    },

    methods: {
        makeTopic(questionArr) {
            this.topics = []

            questionArr.forEach(singleQuestion => {
                let topic = {
                    title: "",
                    titleRT: "",
                    type: 1,
                    analysis: '',
                    analysisRT: '',
                    keyName: '',
                    options: [],
                    error: {
                        title: '',
                        option: '',
                        answer: '',
                    },
                    isError: false,
                }

                let currentStep = ''
                let hasAnswer = false

                singleQuestion.forEach((text, index) => {
                    // 标题
                    if (text.match(nameReg)) {
                        currentStep = 'title'
                        topic.title = text
                        topic.titleRT = text
                        let titleText = text.replace(nameReg, '')

                        if (titleText.trim().length < 1) {
                            topic.error.title = '标题为空！'
                        }
                        return
                    }

                    // 选项：选择题
                    if (text.match(questionReg)) {
                        let optionName = text.match(questionReg)[0]        // 选项 (A)
                        let optionNameKey = optionName.match(/[A-G]/i)[0]  // 选项 A
                        optionNameKey = optionNameKey.toUpperCase()        // 选项 A
                        let optionContent = text.split(optionName)[1]      // 题干 xxxxx

                        currentStep = `option:${optionNameKey}`

                        if (optionContent.trim().length < 1) {
                            topic.error.option = '选项为空！'
                        }

                        topic.options.push({
                            tag: optionNameKey,   // A
                            tagName: optionNameKey,   // A
                            title: optionContent,
                            titleRT: optionContent,
                            isRight: false
                        })
                        return
                    }

                    // 答案
                    if (text.match(answerReg)) {
                        currentStep = 'answer'
                        let m = text.match(answerReg)[0]           // "正确答案："
                        let answer = text.replace(answerReg, '')   // 答案的具体内容
                        answer = answer.replace(/\s*\n*/g, '')

                        hasAnswer = true

                        // 解析答案，判断题型
                        if (answer) {
                            topic.keyName = answer

                            let isSelect = answer.match(/^\s*[A-G]{1,7}\s*(?:\n|$)/i)
                            let isJudge = answer.match(/^\s*[对错]\s*(?:\n|$)/)

                            // 选择题
                            if (isSelect) {
                                answer = answer.toUpperCase()
                                answer = [...new Set(answer.split(''))].join('')    // 去除重复选项，比如"AA"
                                topic.keyName = answer

                                let selectAnswerArr = answer.split('')
                                selectAnswerArr.sort()

                                let length = selectAnswerArr.length

                                // 单选题
                                if (length === 1) {
                                    topic.type = 1

                                    let idx = topic.options.findIndex(v => v.tag === answer)

                                    if (idx > -1) {
                                        topic.options[idx].isRight = true
                                    } else {
                                        // error: 答案不存在
                                        topic.error.answer = '答案不存在!'
                                    }

                                    // 多选题
                                } else if (length > 1) {
                                    topic.type = 2

                                    let allOptions = topic.options.map(v => v.tag)

                                    if (selectAnswerArr.every(v => allOptions.includes(v))) {
                                        topic.options.forEach(v => {
                                            if (selectAnswerArr.includes(v.tag)) {
                                                v.isRight = true
                                            }
                                        })

                                    } else {
                                        // error: 答案不存在
                                        topic.error.answer = '答案不存在!'
                                    }
                                }
                            }

                            // 判断题
                            else if (isJudge) {
                                topic.type = 3

                                topic.options = [{
                                    tag: 1,
                                    tagName: '对',
                                    title: '',
                                    titleRT: '',
                                    isRight: false,
                                }, {
                                    tag: 0,
                                    tagName: '错',
                                    title: '',
                                    titleRT: '',
                                    isRight: false,
                                }]

                                if (answer.indexOf('对') > -1) {
                                    topic.options[0].isRight = true
                                } else if (answer.indexOf('错') > -1) {
                                    topic.options[1].isRight = true
                                } else {
                                    // error: 答案格式错误
                                    topic.error.answer = '答案格式错误!'
                                }
                            }

                            else {
                                topic.error.answer = '答案不存在!'
                            }

                        } else {
                            topic.error.answer = '答案不存在!'
                        }

                        return
                    }

                    // 解析
                    if (text.match(analysisReg)) {
                        currentStep = 'analysis'
                        let m = text.match(analysisReg)[0]   // 解析：
                        let analysis = text.replace(analysisReg, '')
                        analysis = analysis.trim()

                        if (analysis) {
                            topic.analysis = analysis
                            topic.analysisRT = analysis
                        }

                        return
                    }

                    // 处理普通文本（即换行文本的归属问题）
                    if (currentStep.indexOf('option')> -1) {
                        let tag = currentStep.split(':')[1]
                        let option = topic.options.find(item => item.tag === tag)
                        option.titleRT = option.titleRT + '<br/>' + text
                        option.title = option.title + '\n' + text
                    } else if (currentStep === 'title') {
                        topic.titleRT = topic.titleRT + '<br/>' + text
                        topic.title = topic.title + '\n' + text
                    } else if (currentStep === 'analysis') {
                        topic.analysisRT = topic.analysisRT + '<br/>' + text
                        topic.analysis = topic.analysis + '\n' + text
                    }

                })

                this.topics.push(topic)

                /***** 这道题的错误处理 *****/

                // 选择题错误处理
                if (topic.type === 1 || topic.type === 2) {
                    // 最少两个选项
                    if (topic.options.length < 2) {
                        topic.error.option = '选择题至少有两个选项！'
                    }

                    // 选项顺序或数量有误（必须是严格的ABCD）
                    let tags = topic.options.map(item => item.tag)
                    let tagNameOrdered = ''
                    for (let i = 0; i < tags.length; i++) {
                        tagNameOrdered += String.fromCharCode(65 + i)
                    }
                    if (tags.join('') !== tagNameOrdered) {
                        topic.error.option = '选项顺序或数量有误！'
                    }
                }

                // 连“正确答案”这四个字都没写，纯属就没答案
                if (!hasAnswer) {
                    topic.error.answer = '答案不存在!'
                }

                // 如果有错误，则标记之
                if (topic.error.title || topic.error.option || topic.error.answer) {
                    topic.isError = true
                }

                /***** 错误处理 Done *****/

            })
        },

        showExample(type) {
            let lastType = this.example
            this.example = type
            if (lastType === type) {
                $(`#example${type}`).slideUp()
                this.example = 0
            } else {
                $('#example1').hide()
                $('#example2').hide()
                $(`#example${type}`).slideDown()
            }
        },

        removeTitleNumber() {
            this.topics.forEach(item => {
                item.title = item.title.replace(nameReg, '')
                item.titleRT = item.titleRT.replace(nameReg, '')
            })
        },

        saveTopic() {
            if (!this.topics.length) {
                return this.$message.error('导入内容不能为空！')
            }

            if (this.errorNum) {
                return this.$message.error('题目存在错误，请检查后提交！')
            }

            this.$refs['topicForm'].validate((valid) => {
                if (!valid) return

                let queryData = {
                    difficultie: this.topicForm.difficulty,
                    forLevel: this.topicForm.forLevel,
                    knowledgeId: this.topicForm.knowledge[this.topicForm.knowledge.length - 1],
                }

                this.removeTitleNumber()

                this.topicLoading = true;

                this.$api.importTheoryTopic(queryData, this.topics).then(res => {
                    this.$notify.success({
                        title: this.$t('m.importSuccess'),
                        message: res.message,
                    })

                    this.$emit('updateData');
                    this.$router.back();

                }).finally(() => {
                    this.topicLoading = false;
                })

            })
        },

        // 在组卷中使用
        generateTopicInPaper() {
            if (!this.topics.length) {
                return this.$message.error('导入内容不能为空！')
            }

            if (this.errorNum) {
                return this.$message.error('题目存在错误，请检查后提交！')
            }

            this.removeTitleNumber()

            let topic = [...this.topics]

            this.$emit('on-save', topic)
            return topic
        }

    },
}
</script>

<style lang="scss">

$header-height: 40px;
$border-color: #ddd;

.m-addTopicByBatch {

    .el-main {
        //padding: 0;

        .el-card__body {
            display: flex;
            min-height: 0;
            padding-bottom: 30px;
        }
    }

    .batch-wrapper {
        flex: 1;
        display: flex;
        height: 100%;
    }

    .batch-box {
        flex: 1;
        background-color: #fff;
        border: 1px solid $border-color;

        .box-header {
            display: flex;
            align-items: center;
            height: $header-height;
            padding: 0 10px;
            background-color: #F2F4FD;
            border-bottom: 1px solid #ddd;
            box-shadow: 0 1px 4px #eee;

            .title {
                padding-right: 10px;
                font-size: 18px;
                border-right: 1px solid #e6e6e6;
            }

            .toolbar {
                padding-left: 20px;

                button {
                    margin-right: 10px;
                }

                .nucfont {
                    display: inline-block;
                    font-size: 12px;
                    transition: all .3s;
                    &.active {
                        transform: rotate(90deg);
                    }
                }
            }

            .count {
                display: flex;
                padding: 0 10px;
                font-size: 12px;

                b {
                    margin: 0 4px;
                    padding: 0 8px;
                    background-color: $blue;
                    color: #fff;
                    border-radius: 2px;
                    font-size: 14px;
                }

                .total {
                    margin-right: 10px;
                }

                .wrong {
                    b {
                        background-color: $red;
                    }
                }
            }
        }

        .box-body {
            position: relative;
            display: flex;
            flex-direction: column;
            min-height: 0;
            height: calc(100% - #{$header-height});
        }
    }

    .batch-box-result {
        margin-left: 20px;
    }

    .batch-preview {
        position: relative;
        height: 100%;
        padding: 0 15px 12px 15px;
        font-size: 12px;
        line-height: 2;
        color: #656577;
        overflow: auto;
        &:before {
            content: "检查区";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 70px;
            color: #eee;
            letter-spacing: 2px;
            white-space: nowrap;
        }
    }

    .batch-editor {
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: hidden;

        &:before {
            content: "输入区";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 70px;
            color: #eee;
            letter-spacing: 2px;
            white-space: nowrap;
        }

        .ql-toolbar {
            display: none;
            border: 0;
            border-bottom: 1px solid $border-color;
        }

        .ql-container {
            flex: 1;
            border: 0;
            overflow: auto;
        }

        .ql-editor {
            font-size: 12px;
            line-height: 2;
            color: #656577;
        }
    }

    .box-example {
        //flex: 1;
        max-height: 50%;
        padding: 15px;
        font-size: 12px;
        line-height: 2;
        box-shadow: 0 0 4px #ccc;
        overflow: auto;
        display: none;

        .tag {
            margin-bottom: 10px;
            color: $blue;
            font-size: 14px;
        }

        b {
            color: #F76377;
        }
    }

    .batch-form {
        margin-left: 20px;

        .btn-save {
            display: block;
            width: 110px;
            margin: 30px auto 0 auto;
            letter-spacing: 4px;
        }
    }

    .type-tag {
        position: relative;
        display: block;
        margin-bottom: 8px;
        width: 60px;
        height: 22px;
        line-height: 22px;
        border-radius: 1px;
        color: #fff;
        text-align: center;
        user-select: none;

        &.type-single {
            background-color: #ffb822;
            &:before {
                content: '单选题';
            }
        }

        &.type-multi {
            background-color: #2e7faa;
            &:before {
                content: '多选题';
            }
        }

        &.type-judge {
            background-color: #a17e68;
            &:before {
                content: '判断题';
            }
        }
    }

    // 试题能够复用的css
    .paper-list {
        font-size: 12px;

        > li {
            position: relative;
            //margin-bottom: 14px;
            padding: 10px 20px;
            color: #333;
            background-color: #fff;
            border-bottom: 1px solid #ddd;

            + li {
                //border-top: 1px solid #ddd;
            }

            &.is-error {
                background-color: #fff0f0;
            }
        }

        .detail {
            .topic-title {
                margin-bottom: 12px;
                word-break: break-all;

                .type {
                    margin-bottom: 6px;
                    color: #f4516c;
                }

                .titleRT {
                    line-height: 20px;
                }
            }

            .topic-choice-error {
                margin-bottom: 12px;
            }

            .topic-choice {
                //display: flex;
                margin-left: 16px;
                margin-bottom: 8px;

                > label {
                    display: flex;
                    .el-radio__input,
                    .el-checkbox__input {
                        padding-top: 2px;
                    }
                    .el-radio__label,
                    .el-checkbox__label {
                        display: flex;
                        align-items: baseline;
                    }
                }

                em {
                    font-size: 12px;
                    font-style: normal;
                }

                .options {
                    display: inline-block;
                    white-space: normal;
                    word-break: break-all;
                    vertical-align: middle;
                    margin-left: 3px;
                    font-size: 12px;
                    line-height: 20px;
                }

                .el-checkbox {
                    line-height: 1;
                }
            }

        }

        .others {
            padding-left: 5px;

            .answer {
                margin-bottom: 4px;
                line-height: 20px;
            }

            .tag {
                color: #2e7faa;
            }
        }

        .error {
            padding: 4px 10px;
            background-color: $red;
            color: #fff;
        }
    }

    /**
     *  在考卷编辑中的特有样式
     */
    &.from-paper {
        position: relative;
        background-color: #fff;

        .el-main {
            padding: 0;
            .el-card {
                border: none;
            }
            .el-card__body {
                padding: 0;
            }
        }

    }
}
</style>
